module.exports = __webpack_public_path__ + "img/logo-dinapsis-aplicaciones.4a0e1b66.svg";